import { ref } from 'vue'
import { collection, query, where, onSnapshot, orderBy, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { getAuth } from 'firebase/auth'

export const useConversations = (activeConversation) => {  // activeConversation parametresi ekle
  const conversations = ref([])
  const error = ref(null)
  const loading = ref(false)
  let unsubscribe = null;

  const listenToConversations = () => {
    const auth = getAuth()
    if (!auth.currentUser) return

    if (unsubscribe) {
      unsubscribe()
    }

    loading.value = true
    const q = query(
      collection(db, 'conversations'),
      where('participants', 'array-contains', auth.currentUser.uid),
      orderBy('lastMessageTime', 'desc')
    )

    unsubscribe = onSnapshot(q, async (snapshot) => {
      const currentUserId = auth.currentUser.uid;
      const convs = [];

      for (const doc of snapshot.docs) {
        const data = doc.data();
        
        // Aktif konuşma kontrolü ekle - activeConversation prop'unu kullan
        const isActiveConversation = activeConversation?.value?.id === doc.id;
        
        if (!isActiveConversation) {
          // Sadece aktif olmayan konuşmalar için okunmamış mesaj kontrolü yap
          const messagesRef = collection(db, 'conversations', doc.id, 'messages');
          const unreadQuery = query(
            messagesRef,
            where('isRead', '==', false),
            where('senderId', '!=', currentUserId)
          );
          
          const unreadSnapshot = await getDocs(unreadQuery);
          
          convs.push({
            id: doc.id,
            ...data,
            hasUnread: unreadSnapshot.size > 0
          });
        } else {
          // Aktif konuşma için hasUnread'i false olarak bırak
          convs.push({
            id: doc.id,
            ...data,
            hasUnread: false
          });
        }
      }

      conversations.value = convs;
      loading.value = false;
    });

    return unsubscribe;
  }

  return { conversations, error, loading, listenToConversations }
}